/**
 * Luth product options — note + multi image upload → cart line properties
 */
(function () {
  const root = document.querySelector('[data-luth-options]');
  if (!root) return;

  const apiUrl = (root.getAttribute('data-api-url') || '').replace(/\/$/, '');
  const token = root.getAttribute('data-upload-token') || '';
  const formId = root.getAttribute('data-product-form-id') || '';

  function showError(fieldEl, msg) {
    const err = fieldEl.querySelector('.luth-po__error');
    if (!err) return;
    if (msg) {
      err.hidden = false;
      err.textContent = msg;
    } else {
      err.hidden = true;
      err.textContent = '';
    }
  }

  function propNameForNote(key) {
    if (key === 'custom_note') return 'Custom note';
    return key;
  }

  function propNameForImage(index) {
    return index === 0 ? 'Custom image' : 'Custom image ' + (index + 1);
  }

  root.querySelectorAll('[data-field-type="note"]').forEach((fieldEl) => {
    const input = fieldEl.querySelector('.luth-po__input, .luth-po__textarea');
    if (!input) return;
    const key = fieldEl.getAttribute('data-field-key') || 'custom_note';
    input.setAttribute('name', `properties[${propNameForNote(key)}]`);
  });

  root.querySelectorAll('[data-field-type="image"]').forEach((fieldEl) => {
    const fileInput = fieldEl.querySelector('.luth-po__file');
    const urlsBox = fieldEl.querySelector('[data-luth-urls]');
    const previews = fieldEl.querySelector('[data-luth-previews]');
    const drop = fieldEl.querySelector('[data-luth-drop]');
    const maxMb = Number(fieldEl.getAttribute('data-max-size-mb') || 10);
    let maxCount = Math.min(Math.max(Number(fieldEl.getAttribute('data-max-count') || 20), 1), 20);
    /* Legacy metafield default was 6 — treat as 20 until merchant sets another value */
    if (maxCount === 6) maxCount = 20;
    const required = fieldEl.getAttribute('data-required') === 'true';

    if (!fileInput || !urlsBox || !previews) return;

    /** @type {{ url: string, name: string }[]} */
    let items = [];

    function syncRequired() {
      if (required && items.length === 0) {
        fileInput.setAttribute('required', 'required');
      } else {
        fileInput.removeAttribute('required');
      }
    }

    function render() {
      urlsBox.innerHTML = '';
      previews.innerHTML = '';
      items.forEach((item, i) => {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.className = 'luth-po__image-url';
        hidden.name = `properties[${propNameForImage(i)}]`;
        if (formId) hidden.setAttribute('form', formId);
        hidden.value = item.url;
        urlsBox.appendChild(hidden);

        const card = document.createElement('div');
        card.className = 'luth-po__preview-card';
        card.innerHTML =
          `<img class="luth-po__preview-img" alt="" width="72" height="72" src="${item.url.replace(/"/g, '')}">` +
          `<div class="luth-po__preview-meta">` +
          `<span class="luth-po__preview-name"></span>` +
          `<span class="luth-po__preview-ok">Uploaded</span>` +
          `</div>` +
          `<button type="button" class="luth-po__clear" data-idx="${i}">Remove</button>`;
        card.querySelector('.luth-po__preview-name').textContent = item.name || 'Photo ' + (i + 1);
        previews.appendChild(card);
      });

      if (drop) {
        drop.hidden = items.length >= maxCount;
        const sub = drop.querySelector('.luth-po__drop-sub');
        if (sub) {
          sub.textContent =
            items.length +
            '/' +
            maxCount +
            ' photos · JPEG / PNG / WebP · max ' +
            maxMb +
            'MB each';
        }
      }
      syncRequired();
    }

    async function uploadOne(file) {
      if (!apiUrl) throw new Error('Upload API chưa cấu hình trong Theme → Luth Options.');
      if (!token) throw new Error('Upload token thiếu trong Theme → Luth Options.');
      if (file.size > maxMb * 1024 * 1024) throw new Error(`Each image must be under ${maxMb}MB.`);

      const body = new FormData();
      body.append('file', file);
      const res = await fetch(`${apiUrl}/api/upload`, {
        method: 'POST',
        headers: { 'x-luth-upload-token': token },
        body,
        mode: 'cors',
        credentials: 'omit',
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.url) throw new Error(data.error || `Upload failed (${res.status})`);
      return { url: data.url, name: file.name || 'Photo' };
    }

    async function uploadFiles(fileList) {
      const files = Array.from(fileList || []).filter(Boolean);
      if (!files.length) return;

      const room = maxCount - items.length;
      if (room <= 0) {
        showError(fieldEl, `Maximum ${maxCount} photos.`);
        return;
      }
      const batch = files.slice(0, room);
      const truncated = files.length > room;
      showError(fieldEl, '');

      root.classList.add('luth-po--busy');
      if (drop) drop.classList.add('is-busy');

      try {
        for (const file of batch) {
          const item = await uploadOne(file);
          items.push(item);
          render();
        }
        if (truncated) {
          showError(fieldEl, `Added ${batch.length}. Maximum is ${maxCount} photos.`);
        }
      } catch (e) {
        let msg = e && e.message ? e.message : 'Upload failed';
        if (msg === 'Failed to fetch') {
          msg =
            'Không gọi được ' +
            apiUrl +
            '/api/upload (CORS/mạng). Kiểm tra CORS trên server options.';
        }
        showError(fieldEl, msg);
      } finally {
        root.classList.remove('luth-po--busy');
        if (drop) drop.classList.remove('is-busy');
        fileInput.value = '';
      }
    }

    fileInput.addEventListener('change', () => {
      uploadFiles(fileInput.files);
    });

    if (drop) {
      const openPicker = () => {
        if (root.classList.contains('luth-po--busy')) return;
        if (items.length >= maxCount) return;
        fileInput.click();
      };
      drop.addEventListener('click', openPicker);
      drop.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPicker();
        }
      });
      ;['dragenter', 'dragover'].forEach((evt) => {
        drop.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
          drop.classList.add('is-dragover');
        });
      });
      ;['dragleave', 'drop'].forEach((evt) => {
        drop.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
          drop.classList.remove('is-dragover');
        });
      });
      drop.addEventListener('drop', (e) => {
        const list = e.dataTransfer && e.dataTransfer.files;
        if (!list || !list.length) return;
        uploadFiles(list);
      });
    }

    previews.addEventListener('click', (e) => {
      const btn = e.target.closest('.luth-po__clear');
      if (!btn) return;
      const idx = Number(btn.getAttribute('data-idx'));
      if (Number.isNaN(idx)) return;
      items.splice(idx, 1);
      showError(fieldEl, '');
      render();
    });

    render();
  });

  document.addEventListener(
    'submit',
    (ev) => {
      const form = ev.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('m-product-form--main') && !form.querySelector('[name="id"]')) return;

      let blocked = false;
      root.querySelectorAll('[data-field-type="image"]').forEach((fieldEl) => {
        const required = fieldEl.getAttribute('data-required') === 'true';
        const urls = fieldEl.querySelectorAll('.luth-po__image-url');
        const has = Array.from(urls).some((el) => el.value);
        if (required && !has) {
          showError(fieldEl, 'Please upload at least one image before adding to cart.');
          blocked = true;
        }
      });
      root.querySelectorAll('[data-field-type="note"]').forEach((fieldEl) => {
        const required = fieldEl.getAttribute('data-required') === 'true';
        const input = fieldEl.querySelector('.luth-po__input, .luth-po__textarea');
        if (required && input && !String(input.value || '').trim()) {
          showError(fieldEl, 'This field is required.');
          blocked = true;
        }
      });
      if (root.classList.contains('luth-po--busy')) {
        blocked = true;
      }
      if (blocked) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    true
  );
})();
